import { X } from 'lucide-react';
import type { ReactNode } from 'react';

type ModalHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  onClose: () => void;
  closeDisabled?: boolean;
};

export function ModalHeader({
  title,
  description,
  onClose,
  closeDisabled = false,
}: ModalHeaderProps) {
  return (
    <div className="px-6 py-4 border-b bg-neut-200 flex items-center justify-between">
      <div>
        <h2 className="text-lg font-semibold text-neut-prim">{title}</h2>
        {description && <p className="text-sm text-neut-500">{description}</p>}
      </div>
      <button
        className="p-2 hover:bg-neut-100 rounded-lg transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Close"
        onClick={onClose}
        disabled={closeDisabled}
      >
        <X size={20} strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
}
